import CountryDashboard from "@/modules/statisticsCountry/views/SmsCountry.vue"

export const SmsCountryRoutes = [
    {
        name: 'SmsCountry',
        path: '/statistics/country',
        component: CountryDashboard,
    }
];
